'use strict';

var pill = require('../../../../../../../../../../_virtual/pill2.cjs');
var accentColors = require('../../base/accentColors.cjs');

var hasRequiredPill;

function requirePill () {
	if (hasRequiredPill) return pill.__exports;
	hasRequiredPill = 1;

	var accentColors$1 = accentColors.__require();

	var PILL_BASE_COLORS = /*#__PURE__*/ function(PILL_BASE_COLORS) {
	    PILL_BASE_COLORS["success"] = "success";
	    PILL_BASE_COLORS["system"] = "system";
	    PILL_BASE_COLORS["highlight"] = "highlight";
	    PILL_BASE_COLORS["danger"] = "danger";
	    PILL_BASE_COLORS["warning"] = "warning";
	    PILL_BASE_COLORS["info"] = "info";
	    return PILL_BASE_COLORS;
	}({});
	const PILL_COLORS = {
	    ...PILL_BASE_COLORS,
	    ...accentColors$1.AVIARY_ACCENTS
	};

	pill.__exports.PILL_BASE_COLORS = PILL_BASE_COLORS;
	pill.__exports.PILL_COLORS = PILL_COLORS;
	
	return pill.__exports;
}

exports.__require = requirePill;
//# sourceMappingURL=pill.cjs.map
